import { createElement } from 'react'

// Soft public API for CRUD notifications. Re-exported from the feature barrel via
// lazy requires so unrelated `features/event_type_editor` imports do not eagerly
// load Automations / useWorkflows (which poisons Knapsack coverage merges).
export const CrudNotificationsSurface = (props) => {
  const { CrudNotificationsSurface: Surface } = require('./control_panel/sections/more_options/crud_notifications')
  return createElement(Surface, props)
}

export const getNotificationToggleInitialValues = (...args) => (
  require('./control_panel/sections/more_options/crud_notifications/notification_toggles')
    .getNotificationToggleInitialValues(...args)
)

export const getNotificationDraftsInitialValues = (...args) => (
  require('./control_panel/sections/more_options/crud_notifications/notification_content')
    .getNotificationDraftsInitialValues(...args)
)

export const formatCrudNotificationContent = (...args) => (
  require('./control_panel/sections/more_options/crud_notifications/notification_content')
    .formatCrudNotificationContent(...args)
)
